import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Lock } from 'lucide-react';
import { Header, Footer } from '../Layout';

export function MembersOnlyGate() {
  const location = useLocation();
  return (
    <div className="min-h-screen bg-[#000B18]" data-testid="marketplace-members-only">
      <Header />
      <main className="pt-28 pb-16 px-4">
        <div className="max-w-lg mx-auto text-center rounded-2xl border border-white/10 bg-[#041A3B] p-8">
          <Lock className="w-10 h-10 text-[#FFD740] mx-auto mb-4" />
          <h1 className="font-outfit text-2xl sm:text-3xl font-semibold text-white mb-2">Members only</h1>
          <p className="text-[#A0B4CC] text-sm sm:text-base mb-6">
            The AGA Marketplace is available to members only. Sign up or log in to browse our partner merchants and offers.
          </p>
          <div className="flex flex-col sm:flex-row gap-3 justify-center">
            <Link to="/register" className="rounded-full bg-[#FFD740] text-[#000B18] font-semibold px-6 py-2.5 text-sm hover:bg-[#FFE57F] transition-colors" data-testid="members-only-signup-btn">Sign up</Link>
            <Link to="/login" state={{ from: location }} className="rounded-full border border-white/20 text-white px-6 py-2.5 text-sm hover:bg-white/5 transition-colors" data-testid="members-only-login-btn">Log in</Link>
          </div>
        </div>
      </main>
      <Footer />
    </div>
  );
}
